const HUBSPOT_DEAL_BASE_URL = "https://app.hubspot.com/contacts/43829082/record/0-3";

export function getHubspotDealHref(payload: {
  dealId?: string;
  hubspotLink?: string;
}) {
  if (payload.hubspotLink?.trim()) {
    return payload.hubspotLink;
  }

  if (!payload.dealId?.trim()) {
    return "";
  }

  return `${HUBSPOT_DEAL_BASE_URL}/${payload.dealId}`;
}
